export const AUDIO_TYPES = [
  { display_name: "FM/AM Broadcast",          id: "477", type: "inventory_type", value: "2", clusivity: "include" },
  { display_name: "Music Streaming Service",  id: "476", type: "inventory_type", value: "1", clusivity: "include" },
  { display_name: "Podcasts",                 id: "528", type: "inventory_type", value: "3", clusivity: "include" },
  { display_name: "Text To Speech Articles",  id: "479", type: "inventory_type", value: "7", clusivity: "include" },
];
